import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import AlertBullet from "components/AlertBullet/AlertBullet";

const style = ({ theme }) => ({
  outerWithArrow: {
    display: "flex",
    alignItems: "center",
    // position: "relative",
    padding: [12, 0],

    backgroundColor: "#f9ded3",
    color: theme.colors.tertiary1,
    borderRadius: 0,
    borderTop: `5px solid ${theme.colors.quanternary1}`,
    fontSize: "14px",
    fontFamily: "Arial",
    fontWeight: "bold",
    lineHeight: "24px"
  },
  inner: {
    padding: [0, theme.padding.sm]
    // padding: "12px 0 12px 59px"
  }
});

const Errors = ({ classes, children }) => (
  <div className={classes.outerWithArrow} role="alert">
    <AlertBullet error></AlertBullet>
    <div className={classes.inner}>{children}</div>
  </div>
);

Errors.propTypes = {
  children: PropTypes.node
};
export default injectSheet(style)(Errors);
